
import {
  getConsignorDropdownListData,
} from "_services/dropdownServices/dropdownService";
import { CommonDropdownInfinite, Heading } from "components";
// import CommonDropdownInfinite from "components/common/CommonDropdownInfinite/CommonDropdownInfinite";

import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import StorageService from "utils/StorageServices";

const TestingUpload = () => {

  // useEffect(() => {
  //   fetchUsers();
  // }, []);



  //   const fetchUsers = async (search, page, limit) => {
  //     try {
  //       const res = await getConsignorDropdownListData( {
  //         company_id: StorageService.getCompanyId(),
  //         offset: page,
  //         limit,
  //         search
  //       });


  //       if (res?.responseCode === 200) {
  //         const  newVehicles = res?.data?.consignor_list.map((i) => ({
  //           ...i,
  //           name: i.name,
  //           id: i._id,
  //         }));

  //         return {
  //             items:newVehicles,
  //             total: res?.data?.total,
  //           };

  //       } else {
  //         toast.error(res?.responseMessage);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching vehicle list:", error);
  //       toast.error("Error fetching vehicle list.");
  //     }
  //   };

  const fetchUsers = async (search, page, limit) => {
    const res = await getConsignorDropdownListData({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit,
      search
    });
    if (res?.responseCode === 200) {
      const newVehicles = res?.data?.consignor_list.map((i) => ({
        ...i,
        name: i.name,
        id: i._id,
      }));

      return {
        items: res?.data?.consignor_list,
        total: res?.data?.total_record,
      };

    } else {
      toast.error(res?.responseMessage);
    }
  };





  return (
    <>
      <Heading title="LR Upload" />

      <div className="p-4">
        <CommonDropdownInfinite
          label="Select Users"
          fetchData={fetchUsers}
          onChange={() => {}}
          selectedItems={[]}
          isMulti={true}
        />
      </div>

    </>
  );
};

export default TestingUpload;
